import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TestCaseResult, TestStatus } from '../../models/test-case-result';
import { TestCaseResultInsertRequest } from '../../models/test-case-result-insert-request';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class TestCaseResultService {
  private utilityService = inject(UtilityService);

  testCaseResultEndpoint = `${environment.testHubApiUrl}/v1/TestCaseResult`;

  saveTestCaseResult(
    testCaseResultInsertRequest: TestCaseResultInsertRequest,
  ): Observable<TestCaseResult> {
    if (environment.useMockData) {
      return of({
        releaseId: 0,
        testCaseId: testCaseResultInsertRequest.testCaseId,
        status: (testCaseResultInsertRequest.isPass ? 'pass' : 'fail') as TestStatus,
        modifiedByUserId: testCaseResultInsertRequest.userId,
        modifiedOn: new Date(),
        attachments: [],
      });
    }
    return this.utilityService.postRequest<TestCaseResult>(
      `${this.testCaseResultEndpoint}`,
      testCaseResultInsertRequest,
    );
  }
}
